import { FIRST_COMPOSITION_LINE } from '@/utils/benefits/hotel/excelPaste/parseRoomTariffBlock';
import {
  findRoomComposition,
  type RoomTypeKey,
} from '@/utils/benefits/hotel/excelPaste/roomCompositions';
import { useExpertMode } from './useExpertMode';

interface ExpertLineBadgeProps {
  roomType: RoomTypeKey;
  optionIndex?: number;
}

/**
 * Grid line of a composition ("L9" to "L28") shown in Expert mode, so a
 * price can be traced back to its line in the pasted block.
 */
const ExpertLineBadge = ({ roomType, optionIndex }: ExpertLineBadgeProps) => {
  const expertMode = useExpertMode();
  if (!expertMode || optionIndex === undefined) return null;
  const composition = findRoomComposition(roomType, optionIndex);
  if (!composition) return null;

  return (
    <span className="mr-2 rounded bg-brand-50 px-1.5 py-0.5 font-mono text-xs font-medium text-brand-700">
      L{FIRST_COMPOSITION_LINE + composition.row - 1}
    </span>
  );
};

export default ExpertLineBadge;
